import "./article_focusarticle.css";

export default (article) => {
	return `
    <div class="row justify-content-md-center ${article.pageTypeId}">
        <!--div class='${article.imageSpan}'>
            ${article.mainImage}
        </div-->
        
        <div class="col-md-10 col-lg-12 m-0 p-md-0">
            <article class="article__main article__template__${
							article.pageTypeId
						}">
                    <h1 class="article__header">${article.title}</h1>
                    ${
											article.parsedIntro.length > 2
												? `<div class="article__intro">${article.parsedIntro}</div>`
												: ""
										}
                <div class="article__content ck-content">
                    ${article.content}
                </div>
            </article>
        </div>
        ${
					article.hasRightColumn
						? `<div class="col-sm-4 offset-sm-1">${article.rightColumn}</div>`
						: ""
				}
    </div>`;
};
